import { NgFor } from '@angular/common';
import { Component } from '@angular/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { RootState } from '@next/core-lib/app';

import { TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';

import { skipWhile, take } from 'rxjs/operators';

import { EnergySystem, LysineSystem } from '../../models/settings.model';

import { setUomSetting } from '../../store/actions/settings.actions';
import { getEnergySetting, getLysineSetting } from '../../store/selectors/settings.selectors';

@Component({
  selector: 'app-uom-setting',
  templateUrl: './uom-setting.component.html',
  styleUrls: ['./uom-setting.component.scss'],
  imports: [MatRadioGroup, ReactiveFormsModule, FormsModule, NgFor, MatRadioButton, TranslatePipe],
})
export class UomSettingComponent {
  energySystem: EnergySystem[];
  lysineSystem: LysineSystem[];
  selectedEnergySystem: EnergySystem;
  selectedLysineSystem: LysineSystem;

  constructor(private readonly store: Store<RootState>) {
    store
      .select(getEnergySetting)
      .pipe(
        skipWhile((setting: EnergySystem) => setting === null),
        take(1),
      )
      .subscribe((setting: EnergySystem) => (this.selectedEnergySystem = setting));
    store
      .select(getLysineSetting)
      .pipe(
        skipWhile((setting: LysineSystem) => setting === null),
        take(1),
      )
      .subscribe((setting: LysineSystem) => (this.selectedLysineSystem = setting));

    this.energySystem = Object.values(EnergySystem);
    this.lysineSystem = Object.values(LysineSystem);
  }

  changeSystem(value: string, system: string): void {
    if (!!value && !!system) {
      this.store.dispatch(setUomSetting({ system, value, save: true }));
    }
  }
}
